import Axios from 'axios';

const axiosInstance = Axios.create({
    baseURL : 'https://react-burger-builder-4c80b.firebaseio.com/'
});

export default axiosInstance;